


















































































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";
import { Watch } from "vue-property-decorator";
import Customer from "@/types/customer/Customer";
import formatDate from "@/utils/formatDate";
import UserInterface from "@/types/app/IUser";
import Endpoint from "@/utils/endpoint";

@Component({})
export default class ModalInteretsDetail extends Vue {
  @Getter("getModalRefusedState", { namespace: "customer" })
  ModalRefusedState!: boolean;
  @Getter("getCustomer", { namespace: "customer" }) customer!: Customer;
  @Getter("getModalRefuseState", { namespace: "customer" })
  modalRefuseState!: boolean;
  @Getter("getUndoRefused", { namespace: "customer" })
  undoRefused!: boolean;
  @Getter("getLoading", { namespace: "customer" }) loading!: boolean;

  @Action("setModalRefuseState", { namespace: "customer" })
  setModalRefuseState!: any;
  @Action("setModalRefusedState", { namespace: "customer" })
  setModalRefusedState!: any;
  @Action("setUndoRefused", { namespace: "customer" })
  setUndoRefused!: any;
  @Action("setCustomers", { namespace: "customer" }) setCustomers!: any;
  @Action("setLoading", { namespace: "customer" }) setLoading!: any;

  private endpoint = new Endpoint();

  formatDate = formatDate;

  refusing = false;
  successRefused = false;
  commentForRefuse = "";

  get relationShip(): string {
    if (this.customer && this.customer.relationships) {
      for (let i = 0; i < this.customer.relationships.length; i++) {
        if (this.customer.relationships[i].typeRelationship === 1) {
          return this.customer.relationships[i].name;
        }
      }
    }

    return "";
  }

  get evaluator(): string {
    if (this.customer && this.customer.relationships) {
      for (let i = 0; i < this.customer.relationships.length; i++) {
        if (this.customer.relationships[i].typeRelationship === 0) {
          return this.customer.relationships[i].name;
        }
      }
    }

    return "";
  }

  async undoRefuseClient(): Promise<void> {
    this.refusing = true;
    this.setLoading(true);
    try {
      await this.$http.put(this.endpoint.undoRefuse, {
        refuseCustomer: {
          customerId: this.customer.id,
          comment: this.commentForRefuse
        }
      });

      this.customer.refuseComment = this.commentForRefuse;
      this.commentForRefuse = "";

      this.refusing = false;

      this.successRefused = true;
      this.setModalRefusedState(false);
      this.setUndoRefused(true);
    } catch (error) {
      this.refusing = false;
      console.error("error", error);
    }
    this.setLoading(false);
  }

  async refreshCustomers(): Promise<void> {
    this.setLoading(true);
    try {
      const response = await this.$http.get(`${this.endpoint.customers}`);
      this.setCustomers(response.data);
    } catch (error) {
      console.error(error);
    }
    this.setLoading(false);
  }

  async handleUndoRefuseClient() {
    await this.undoRefuseClient();
    await this.refreshCustomers();
  }

  closeModal(): void {
    this.setModalRefusedState(false);
  }
}
